module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"avg":"power &#8960; (W)","max":"power max (W)","kWh":"power consumption (kWh)"},"de":{"avg":"Leistung &#8960; (W)","max":"Leistung max (W)","kWh":"Stromverbrauch (kWh)"}}')
  delete Component.options._Ctor
}
